module.exports = __webpack_public_path__ + "static/img/TR@2x.b4d9918c.jpg";